<!-- TODO: PM - This will only be displayed when all EKG prices are better than all the clinic prices.
  This will require a property from the backend and needs to be checked in the parent component.
  That will be added later.
-->
<span class="price-status truncate" [title]="label">
  <mat-icon class="price-status-icon material-icons-outlined" [title]="label">price_check</mat-icon>
  <span class="price-status-label truncate" [title]="label">{{ label }}</span>
</span>
